export default "__VITE_ASSET__ZCQLWULw__"